// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"checkbox-v3_checkbox__z_27t","disabled":"checkbox-v3_disabled__QicQ0","checked":"checkbox-v3_checked__ibpOS","icon":"checkbox-v3_icon__9LtY2"};